import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index',
    meta: { keepAlive: false, loginRequired: false, title: '登录' },
  },
  {
    path: '/home',
    name: 'home',
    meta: { keepAlive: true, loginRequired: true, title: '首页' },
    component: () => import('../views/home/Index.vue'),
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'poster',
        component: () => import('../views/poster/poster.vue'),
      },
    ],
  },
  {
    path: '/customerTotal',
    name: 'customerTotal',
    component: () => import('../views/customer/customerTotal.vue'),
  },
  {
    path: '/reply',
    name: 'reply',
    component: () => import('../views/fastReply/index.vue'),
  },
  {
    path: '/interTab',
    name: 'interTab',
    component: () => import('../views/fastReply/interTab.vue'),
  },
  {
    path: '/channel',
    name: 'channel',
    component: () => import('../views/channel/index.vue'),
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../views/channel/detail.vue'),
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/customer/index.vue'),
  },
  {
    path: '/info',
    name: 'Info',
    // component: () => import('../views/studentInfo/index.vue'),
    component: () => import('../views/studentInfo/student.vue'),
  },
  {
    path:'/addRecord',
    name: 'addRecord',
    component: () => import('../views/studentInfo/addRecord.vue')
  },
  {
    path:'/addTel',
    name: 'addTel',
    component: () => import('../views/studentInfo/addTel.vue')
  },
  {
    path: "/loss/:userId/:tenId",
    name: 'loss',
    component: () => import('../views/studentInfo/lossStudent.vue'),
  },
  {
    path:'/apply',
    name: 'apply',
    component: () => import('../views/studentInfo/apply.vue')
  },
  { path: '/poster',
    name: 'playbill',
    component: () => import('../views/poster/playbill.vue'),
  },
  {
    path: '/posterDetail',
    name: 'posterDetail',
    component: () => import('../views/poster/posterDetail.vue'),
  },
  {
    path: '/servercard',
    name: 'servercard',
    component: () => import('../views/studentInfo/servercard.vue'),
  },
  {
    path: '/material',
    name: 'material',
    component: () => import('../views/material/index.vue'),
  },
  {
    path: '/materialdetail',
    name: 'materialdetail',
    component: () => import('../views/material/detail.vue'),
  },
  {
    path: '/customerGroup',
    name: 'customerGroup',
    component: () => import('../views/wegroupsend/index.vue'),
  },
  {
    path: '/addCustomer',
    name: 'addCustomer',
    component: () => import('../views/customer/addCustomer.vue'),
  },
  {
    path: '/lossCustomer',
    name: 'lossCustomer',
    component: () => import('../views/customer/lossCustomer.vue'),
  },
  {
    path: '/tuition',
    name: 'tuition',
    component: () => import('../views/tuition/index.vue'),
  },
  {
    path: '/myServices',
    name: 'myServices',
    component: () => import('../views/myServices/index.vue')
  },
  {
    path: '/pass',
    name: 'pass',
    component: () => import('../views/myServices/submitPass.vue')
  },

  // {
  //   path: '*',
  //   redirect: '/index',
  // },
  //  快捷回复-新建个人话术
  {
    path: '/newReply',
    name: 'newReply',
    component: () => import('../views/wegroupsend/newReply.vue'),
  },
  {
    path: '/groupCodeList',
    name: 'groupCodeList',
    component: () => import('../views/groupCode/index.vue'),
  },
  {
    path: '/groupCodeDetail',
    name: 'groupCodeDetail',
    component: () => import('../views/groupCode/detail.vue'),
  },
  {
    path: '/studentInfoEnter',
    name: 'studentInfoEnter',
    component: () => import('../views/studentInfo/enterInfo.vue'),
  },
  {
    path: '/quicklyOrder',
    name: 'quicklyOrder',
    component: () => import('../views/studentInfo/quicklyOrder.vue'),
  },
  {
    path: '/openClassList',
    name: 'openClassList',
    component: () => import('../views/studentInfo/openClassList.vue'),
  },
  {
    path: '/openFile',
    name: 'openFile',
    component: () => import('../views/fastReply/openFile.vue'),
  },
  {
    path: '/lose',
    name: 'lose',
    component: () => import('../views/fastReply/losePage.vue'),
  },
  //  资产出入口
  {
    path: '/assetsIndex',
    name: 'assetsIndex',
    component: () => import('../views/administration/index.vue'),
  },
  //  资产出库
  {
    path: '/assetsOut',
    name: 'assetsOut',
    component: () => import('../views/administration/aeestsOut.vue'),
  },
  {
    path: '/assetsEnter',
    name: 'assetsEnter',
    component: () => import('../views/administration/assetsEnter.vue'),
  },
  {
    path: '/linkNoLimit',
    name: 'linkNoLimit',
    component: () => import('../views/linkLimit/index.vue'),
  },
  {
    path: '/setLabel',
    name: 'setLabel',
    component: () => import('../views/setLabel/index.vue'),
  },
  {
    path: '/telSuccess',
    name: 'telSuccess',
    component: () => import('../views/studentInfo/telSuccess.vue')
  },
  // {
  //   path: '/newStudent',
  //   name: 'newStudent',
  //   component: () => import('../views/studentInfo/student.vue'),
  // },

  { // 素材库
    path: '/materialLibrary',
    name: 'materialLibrary',
    component: () => import('../views/materialLibrary/materialLibrary.vue')
  },
  { // 素材列表
    path: '/materialList',
    name: 'materialList',
    component: () => import('../views/materialLibrary/materialList.vue')
  },
  // 训练营海报列表
  {
    path: '/trainingCamp',
    name: 'trainingCamp',
    component: () => import('../views/trainingCamp/index.vue'),
  },
  {
    path: '/trainingCampdetail',
    name: 'trainingCampdetail',
    component: () => import('../views/trainingCamp/detail.vue'),
  },
]


const router = new VueRouter({ mode: 'history', routes })
router.beforeEach((to, from, next) => {
    next()
})
export default router
